import { render, staticRenderFns } from "./entities-menu.vue?vue&type=template&id=1aa23c59&"
import script from "./entities-menu.component.ts?vue&type=script&lang=ts&"
export * from "./entities-menu.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports